import cipher6image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/6/image1.webp';
import cipher6image2 from '../../../../assets/images/games/zdar-escape-game/ciphers/6/image2.webp';

const hints = [
    {
        image: cipher6image1,
    },
    {
        image: cipher6image2,
    },
];
export const step6falconry = {
    id: 6,
    title: '2. stanoviště',
    cipher: {
        text: 'Vyražte k budově, nad kterou on a ještě jeden další sokol létá. Až budete na místě, klikněte na tlačítko "Dále".',
        label: 'Úkol',
    },
    catImage: 1,
    continueButtonText: 'Dále',
    hints: hints,
    snowHints: hints,
};
